import { render } from "./AgreementSection.vue?vue&type=template&id=b57e7b0c"
import script from "./AgreementSection.vue?vue&type=script&lang=ts"
export * from "./AgreementSection.vue?vue&type=script&lang=ts"

import "./AgreementSection.vue?vue&type=style&index=0&id=b57e7b0c&lang=scss"
script.render = render

export default script